import { render } from "./ContactCoach.vue?vue&type=template&id=eaa74428&scoped=true"
import script from "./ContactCoach.vue?vue&type=script&lang=js"
export * from "./ContactCoach.vue?vue&type=script&lang=js"

import "./ContactCoach.vue?vue&type=style&index=0&id=eaa74428&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-eaa74428"

export default script